import { LoyaltyRewardsListWidget as LoyaltyRewardsListItemPage } from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-widgets/loyalty-rewards-list-widget';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function RewardsItemPage() {
  return <LoyaltyRewardsListItemPage />;
}
